import { getAsDateFromMinutes } from '../PartialSliderHelper';
import { isRangeOverlapping } from '../../../common-client2/src/services/dateTime';

/**
 * @typedef {import('../SliderThreshold').ShiftRequestRange } ShiftRequestRange
 * @typedef {import('../SliderThreshold').PartialOffer } PartialOffer
 * @typedef {import('../SliderThreshold').PartialOfferWithLabel } PartialOfferWithLabel
 * @typedef {[number, number]} SliderSelection
 */

/**
 * @param {ShiftRequestRange} shiftRequestRange Used to get the `anchorDate`
 * @param {SliderSelection} selection
 * @param {PartialOfferWithLabel[][]} takenOffersWithLabel
 * @returns {PartialOfferWithLabel|boolean} The overlapped range, `false` otherwise.
 */
export const isSelectionAlreadyTaken = (shiftRequestRange, selection, takenOffersWithLabel) => {

    // isset
    if (!Object.keys(shiftRequestRange || {}).length || !selection?.length) {
        return false;
    }

    const { startDateTime: anchorDate } = shiftRequestRange;
    const startSelection = getAsDateFromMinutes(anchorDate, selection[0]);
    const endSelection = getAsDateFromMinutes(anchorDate, selection[1]);

    const isTakenFound = takenOffersWithLabel.find((o) => isRangeOverlapping(
        startSelection,
        endSelection,
        o.partialFromDate,
        o.partialToDate,
        true,
    ));

    if (isTakenFound) {
        // Returns the overlapped range
        return isTakenFound;
    }

    return false;
};
